export default __webpack_public_path__ + "static/media/Paddon1.bf5c83ee.png";